export default ({ request }) => ({
  sampleStockBatchReturnListApi(data = {}) {
    return request({
      url: '/samplemanage/billStockBatchReturnMain/list',
      method: 'post',
      data
    })
  },
  sampleStockBatchReturnDetailApi(data = {}) {
    return request({
      url: '/samplemanage/billStockBatchReturnMain/detail',
      method: 'post',
      data
    })
  },
  sampleStockBatchReturnSaveApi(data = {}) {
    return request({
      url: '/samplemanage/billStockBatchReturnMain/save',
      method: 'post',
      data
    })
  },
  sampleStockBatchReturnDelApi(data = {}) {
    return request({
      url: '/samplemanage/billStockBatchReturnMain/del',
      method: 'post',
      data
    })
  },
  sampleStockBatchReturnAuditApi(data = {}) {
    return request({
      url: '/samplemanage/billStockBatchReturnMain/audit',
      method: 'post',
      data
    })
  }
})
